import PropTypes from 'prop-types';

const customPropTypes = {
  prefetch: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.oneOf([null])]),
};

export default customPropTypes;
